import useMediaQueryMUI from '@mui/material/useMediaQuery';
import { Breakpoint, useTheme } from '@mui/material/styles';



const useMediaQuery = (breakpoint: Breakpoint): Boolean => {
  const theme = useTheme();
  const matches = useMediaQueryMUI(theme.breakpoints.down(breakpoint));
  return matches;
};

export default useMediaQuery;